import { createClient, type Client } from "@connectrpc/connect";
import type { DescService } from "@bufbuild/protobuf";
import { grpcTransportProvider } from "./GrpcTransport";
import { mapConnectError } from "./mapConnectError";

/** Cliente gRPC-Web del servicio dado sobre el transporte único de la app (token incluido). */
export function grpcClient<T extends DescService>(service: T): Client<T> {
  return createClient(service, grpcTransportProvider.get());
}

/** Ejecuta una llamada gRPC y traduce su error a la jerarquía de errores de la app
 *  (`ValidationError`, `NotFoundError`, …) para que las páginas no sepan del transporte. */
export async function grpcCall<T>(llamada: () => Promise<T>): Promise<T> {
  try {
    return await llamada();
  } catch (error) {
    throw mapConnectError(error);
  }
}

/** Unix ms (int64 → bigint) a `Date`; `null` si el campo opcional no vino. */
export function msToDate(ms: bigint | undefined): Date | null {
  return ms !== undefined ? new Date(Number(ms)) : null;
}

/** `Date` / string ISO a Unix ms (bigint) para enviar; `undefined` si no hay fecha. */
export function dateToMs(fecha: Date | string | null | undefined): bigint | undefined {
  if (fecha == null || fecha === "") return undefined;
  const ms = new Date(fecha).getTime();
  return Number.isNaN(ms) ? undefined : BigInt(ms);
}
